import {css} from 'styled-components'

const sizes = {
  desktop: 1260,
  tablet: 768,
  phone: 480 // 375
}

export const mediaCss = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `
  return acc
}, {})

export const mediaJs = key => {
  if (typeof window === 'undefined') return false
  // return window.matchMedia(`(max-width: ${sizes[key]}px)`).matches // todo
  const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  return clientWidth <= sizes[key]
}
